import $ from 'jquery'

export default () => {
    let base = $('base')

    if (base.length <= 0 || typeof base.attr('href') === 'undefined' || base.attr('href') === false) {
        return;
    }

    $('a[href^="/"]').each(function (index, value) {
        let a = $(value)
        let href = base.attr('href')

        href += href.slice(-1) !== '/' ? '/' : ''
        href += a.attr('href').slice((a.attr('href').length - 1) * -1)

        a.attr('href', href)
    });
}
